module.exports = __webpack_public_path__ + "static/media/vat.84dc6b01.jpeg";